
const resetUnlock = () => {
    document.exitPointerLock()

    const cam = document.getElementById("camera")
    const rot = cam.getAttribute("rotation")

    cam.setAttribute("rotation", {
        x: 0,
        y: 0,
        z: 0,
    })
}

export const enableHUD = () => {

    return {
        type: "HUD_ENABLE"
    }
}

export const disableHUD = () => {

    return {
        type: "HUD_DISABLE"
    }
}

export const speechErrorHUD = () => {

    return {
        type: "HUD_SPEECH_ERROR"
    }
}

export const setLinkHUD = (link) => {
    // document.exitPointerLock();
    // resetUnlock()

    return {
        type: "HUD_SET_LINK",
        link: link,
    }
}

export const switchSpaceHUD = () => {
    resetUnlock()

    return {
        type: "HUD_SPACE_SELECT",
    }
}

export const generateLinkHUD = () => {
    resetUnlock()

    return {
        type: "HUD_LOADING"
    }
}


// WEBPACK FOOTER //
// ./src/actions/hud.js